/**
 * Obuna oldindan to'lovi: oylik narx × oy — chegirma.
 * 3 oy 5%, 6 oy 10%, 12 oy — tarif bo'yicha yillik (start 10%, kichik 15%, o'rta 20%, yirik 25%).
 * Backend `Tariff::subscriptionPrepayFromMonthly` bilan mos.
 */

export const SUBSCRIPTION_PREPAY_OPTIONS = [1, 3, 6, 12] as const;
export type SubscriptionPrepayMonths = (typeof SUBSCRIPTION_PREPAY_OPTIONS)[number];

/** `planTypeKey` — tenant `plan_key` / tarif `type_key` (masalan `businessMedium`). */
export function yearlyDiscountRatioForPlanType(planTypeKey: string | null | undefined): number {
  const k = String(planTypeKey || '').trim();
  switch (k) {
    case 'start':
      return 0.1;
    case 'businessSmall':
      return 0.15;
    case 'businessMedium':
      return 0.2;
    case 'businessEnterprise':
      return 0.25;
    default:
      return 0.1;
  }
}

export function prepayDiscountRatio(months: number, planTypeKey?: string | null): number {
  if (months === 3) return 0.05;
  if (months === 6) return 0.1;
  if (months === 12) return yearlyDiscountRatioForPlanType(planTypeKey);
  return 0;
}

export function prepayBaseTotalUzs(monthlyUzs: number, months: number): number {
  return Math.max(0, Math.round(Number(monthlyUzs) || 0) * months);
}

export function prepayTotalAfterDiscountUzs(
  monthlyUzs: number,
  months: number,
  planTypeKey?: string | null,
): number {
  const base = prepayBaseTotalUzs(monthlyUzs, months);
  const r = prepayDiscountRatio(months, planTypeKey);
  return Math.max(0, Math.round(base * (1 - r)));
}

export function prepayDiscountPercentLabel(months: number, planTypeKey?: string | null): string | null {
  const p = Math.round(prepayDiscountRatio(months, planTypeKey) * 100);
  return p > 0 ? `-${p}%` : null;
}
